import Logo from '../../assets/logo.svg';
import APlus_ABankLogo from '../../assets/aplus-logo-40x40.png';
import { isDevelopment } from '../../utils/version';
import WebPImage from '../WebPImage/WebPImage';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isGlobalSiteHost } from '../../utils/siteHost';
import { globalCompliance } from '../../config/globalCompliance';

function Footer() {
  const { t } = useTranslation();
  const isGlobalSite = isGlobalSiteHost();

  return (
    <footer className="w-full py-6 bg-white backdrop-blur-[20px] backdrop-saturate-[180%] border-t border-gray-200/20 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-1">
          {isDevelopment() && (
            <div className="flex flex-row items-center justify-center gap-1">
              <span className="text-xs text-gray-700">
                UAT site: All content is for demonstration purposes only.
              </span>
            </div>
          )}
          <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
            By using this app, you agree to our <Link to="/terms-of-service">Terms of Service</Link>{' '}
            and <a href="/privacy-policy">Privacy Policy</a>.{' '}
            {isGlobalSite && <Link to="/compliance-policy">Global EZTopup Compliance Policy</Link>}{' '}
            ·{' '}
            <Link to="/account-deletion">
              {t('account_deletion.footer_link', 'Account Deletion')}
            </Link>
            .
          </div>
          {!isGlobalSite && (
            <div className="flex flex-row items-center justify-center gap-1">
              <div className="flex flex-row items-center justify-center gap-1">
                <p className="text-xs text-gray-700">Powered by</p>
                <div className="flex items-center h-[10px] w-fit">
                  <img
                    src={Logo}
                    alt="Logo"
                    className="object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
                    style={{ width: '20px' }}
                  />
                </div>
              </div>
              <span> | </span>
              <div className="flex flex-row items-center justify-center gap-1">
                <p className="text-xs text-gray-700">Payment Partnership with</p>
                <div className="flex items-center h-[10px] w-fit">
                  <WebPImage
                    src={APlus_ABankLogo}
                    alt="A+ Bank Logo"
                    className="object-cover"
                    style={{ width: '30px' }}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          )}
          <div className="flex flex-col items-center gap-1">
            {isGlobalSite && (
              <div className="max-w-3xl text-center text-[10px] leading-5 text-gray-600">
                <p>{globalCompliance.serviceDisclosure}</p>
                <p>
                  {globalCompliance.companyName} · {globalCompliance.addressLines.join(', ')}
                </p>
              </div>
            )}
            <p className="whitespace-pre-line text-[10px] text-gray-600">
              {isGlobalSite
                ? '© 2026 MyEZTopup. All rights reserved.'
                : `© ${new Date().getFullYear()} All rights reserved.`}
            </p>
            {/* {isDevelopment() && ( */}
            {/* <p className="text-[9px] text-gray-600 font-mono">v{getFullVersionInfo()}</p> */}
            {/* )} */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
